import { useState, useEffect, useCallback } from "react";
import { message } from "antd";
import { getOperationEnums, EnumOption } from "../services/operationService";

export const usePermissionEnums = () => {
  const [serviceOptions, setServiceOptions] = useState<EnumOption[]>([]);
  const [serviceOptionsForForm, setServiceOptionsForForm] = useState<EnumOption[]>([]);
  const [pageOptions, setPageOptions] = useState<EnumOption[]>([]);
  const [resourceOptions, setResourceOptions] = useState<EnumOption[]>([]);
  const [actionOptions, setActionOptions] = useState<EnumOption[]>([]);
  const [statusOptions, setStatusOptions] = useState<EnumOption[]>([]);
  const [typeOptions, setTypeOptions] = useState<EnumOption[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  // 根据微服务获取页面选项（简化版本）
  const fetchPageOptions = useCallback(async (serviceName: string) => {
    // 简化实现，返回空数组
    setPageOptions([]);
  }, []);

  const fetchEnums = useCallback(async () => {
    try {
      setLoading(true);
      const response = await getOperationEnums();

      if (response) {
        const { services, actions, pages, statuses } = response;

        // 处理服务选项 - 用于搜索（包含全部选项）
        const formattedServiceOptions = [{ key: "all", value: "", label: "全部" }, ...(services || [])];
        setServiceOptions(formattedServiceOptions);

        // 处理服务选项 - 用于表单（不包含全部选项）
        setServiceOptionsForForm(services || []);

        // 处理服务选项 - 用于资源搜索
        const formattedResources = [{ key: "all", value: "", label: "全部" }, ...(services || [])];
        setResourceOptions(formattedResources);

        // 处理页面选项
        const formattedPages = [{ key: "all", value: "", label: "全部" }, ...(pages || [])];
        setPageOptions(formattedPages);

        // 处理操作选项 - 使用硬编码的操作列表
        const hardcodedActions = [
          { label: "view", value: "view" },
          { label: "create", value: "create" },
          { label: "update", value: "update" },
          { label: "delete", value: "delete" },
          { label: "export", value: "export" },
          { label: "import", value: "import" },
        ];
        const formattedActions = [
          { key: "all", value: "*", label: "全部操作" }, // 修改为"*"，与权限代码生成一致
          ...hardcodedActions,
        ];
        setActionOptions(formattedActions);

        // 处理状态选项 - 用于表单（不包含全部选项）
        const formattedStatuses = [
          { key: "active", value: "active", label: "启用" },
          { key: "inactive", value: "inactive", label: "禁用" },
        ];
        setStatusOptions(formattedStatuses);

        // 设置类型选项 - 修复value类型问题
        setTypeOptions([
          { key: "all", value: "", label: "全部" }, // 修改为空字符串
          { key: "FUNCTION", value: "FUNCTION", label: "功能权限" }, // 值必须与后端一致
          { key: "DATA", value: "DATA", label: "数据权限" },
          { key: "UI", value: "UI", label: "UI权限" },
          { key: "API", value: "API", label: "API权限" },
          { key: "MENU", value: "MENU", label: "菜单权限" },
        ]);
      }
    } catch (error) {
      message.error("获取搜索条件选项失败");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchEnums();
  }, [fetchEnums]);

  return {
    serviceOptions,
    serviceOptionsForForm,
    pageOptions,
    resourceOptions,
    actionOptions,
    statusOptions,
    typeOptions,
    loading,
    refresh: fetchEnums,
    fetchPageOptions,
  };
};
